import { computed, type Ref } from 'vue'
import { useUser } from '@gat-ship/user'
import type { TargetPromptAiModel } from '../model/types'
import { AI_PERMISSIONS } from '../constants'

export function useAiModelSelection(
  selectedThinkingModel: Ref<TargetPromptAiModel | undefined>
) {
  const user = useUser()

  const canOverrideModel = computed(() =>
    user.hasPermission(AI_PERMISSIONS.overrideModel)
  )

  function getAiModelOverride():
    | Omit<TargetPromptAiModel, 'default'>
    | undefined {
    if (!canOverrideModel.value) return undefined
    return selectedThinkingModel.value === 'default'
      ? undefined
      : selectedThinkingModel.value
  }

  return {
    canOverrideModel,
    getAiModelOverride
  }
}
